<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl">

      <template #form="scope">
        <div class="form-group">
          <label>Menu</label>
          <v-select
            v-model="scope.data.MenuID"
            :options="listMenus"
            :reduce="item => item.ID"
            label="Name"/>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="scope.data.AccessCreate">
          <label class="form-check-label">Akses Tambah Data</label>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="scope.data.AccessUpdate">
          <label class="form-check-label">Akses Ubah Data</label>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="scope.data.AccessDelete">
          <label class="form-check-label">Akses Hapus Data</label>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="scope.data.AccessDetail">
          <label class="form-check-label">Akses Detail Data</label>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="`${apiUrl}?roleId=${$route.params.id}`"
      :fields="tableFields"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.loadOptionData()

    this.scopedFormData.RoleID = parseInt(this.$route.params.id)
  },
  
  data() {
    return {
      apiUrl: `/role-menu`,
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Menu', label: 'Menu', formatter: value => value ? value.Name : '' },
        { key: 'AccessCreate', label: 'Akses Tambah', formatter: value => this.$helper.textColorMarking(value) },
        { key: 'AccessUpdate', label: 'Akses Ubah', formatter: value => this.$helper.textColorMarking(value) },
        { key: 'AccessDelete', label: 'Akses Hapus', formatter: value => this.$helper.textColorMarking(value) },
        { key: 'AccessDetail', label: 'Akses Detail', formatter: value => this.$helper.textColorMarking(value) }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        // RoleID: null,
        MenuID: null,
        AccessCreate: null,
        AccessUpdate: null,
        AccessDelete: null,
        AccessDetail: null
      },
      scopedDetailData: {},
      listMenus: []
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.get('/menu').then((res) => {
        this.listMenus = res.data
      })
    }
  }
}
</script>
